import { useState, useEffect } from 'react';
import { ICandidateResumeDownloadResponse } from '../models/candidateProfile.model';
import { axiosCandidatesResumeDownload } from '../stateManagement/api';

const useCandidateResumeDownload = (fileName: string, enabled = true) => {
  const [resumeDetailsDownload, setResumeDetailsDownload] =
    useState<ICandidateResumeDownloadResponse>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (!enabled || !fileName) {
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        setLoading(true);
        const response = await axiosCandidatesResumeDownload(fileName);
        if (!cancelled) {
          setResumeDetailsDownload(response);
          setError(null);
        }
      } catch (apiError: any) {
        if (!cancelled) {
          setError(apiError.message);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [fileName, enabled]);

  return { resumeDetailsDownload, loading, error };
};

export default useCandidateResumeDownload;
